import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import ElskePic from "../DublinAssets/DublinMessagesAssets/Message-ProfilePic.webp";

export const DublinMessageContent: Chat_content[] = [
  {
    icon: ElskePic,
    name: "Elske",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content:
            "You don’t get to kiss me like today in front of the crew and then pretend we’re just ‘colleagues’. You pursued me. You told me Dublin felt like magic because of us. And now you’re freezing me out mid-shoot? Coward.",
        },
        timestamp: "2025-04-08T10:14:00.000Z",
        from: "Elske",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I shouldn’t have kissed you, that crossed a line. I didn’t mean to confuse you. But I can’t—I won’t—let this derail the production. I know it’s not easy for you given that we’re breaking up, but I need your full commitment as DOP.",
        },
        timestamp: "2025-04-09T06:43:00.000Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "*Voice Note - 2.33 mins*",
        },
        timestamp: "2025-04-09T07:02:00.000Z",
        from: "Elske",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "You have my full commitment. You gave me 2 days ‘compassionate leave’ last week, remember? I don’t need pity, I want you to admit you’re scared. You’d rather lose me than risk looking unprofessional.",
        },
        timestamp: "2025-04-09T07:06:00.000Z",
        from: "Elske",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "It’s not about professionalism. It’s about me. I can’t be this version of myself right now—the one who stays up until dawn tracing your freckles. I need to be the director. And yes, that makes me a coward. But it doesn’t mean what we had wasn’t real.",
        },
        timestamp: "2025-04-09T07:30:00.000Z",
        from: "Me",
        status: "Read",
      },
    ],
  },
];
